// The hard limit for a message is 1600 chars by Twilio,
// but we send the message with more about how to opt out of messaging,
// so picking a lower number as a hard limit
export const LONGEST_ALLOWABLE_TEXT = 1500 as const;
export const EMAIL_SUGGESTION_WARNING =
  'We suggest using email for messages of this length.' as const;
export const LONG_TEXT_MESSAGE_ERROR =
  `Text messages must be shorter than ${LONGEST_ALLOWABLE_TEXT} characters. ${EMAIL_SUGGESTION_WARNING}` as const;
export const REQUIRED_SUBJECT_TEXT = 'Subject is required' as const;

export const CHARS_TO_SUGGEST_SWITCHING_TO_EMAIL = 600 as const;

export const BRACKET_ERROR = (target: 'subject' | 'message') =>
  `Your ${target} is invalid, please close all of your brackets.` as const;
